import { FC } from 'react';

import styles from './index.module.scss';

const Loader: FC = () => (
	<div className={styles.loader}>
		<span></span>
		<span></span>
	</div>
);

export default Loader;
